<template>
  <div>
    <div class="testprofile">
      <!--3.资料登记-->
      <div class="flex-x-center">
        <div class="profile-content">
          <div class="my-photo">我的照片</div>
          <div class="flex-x-center">
            <img class="my-headimg" :src="$parent.userCertInfo.id_image" alt="" />
          </div>
          <div class="my-photo">基本信息</div>
          <div class="flex-x-center">
            <div style="width: 80%">
              <form-create v-model="fApi" :rule="fRule" :option="option"></form-create>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="flex-x-center agree-sign-next">
      <button class="next-step" @click="checkFormData()">提交</button>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { reqProjectSavedata, reqProjectDetail } from "@/api";
import { erroralert, successalert } from "@/utils/alert";
export default {
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
    }),
    fRule() {
      return this.process && this.process.content && this.process.content.field_list
        ? this.process.content.field_list
        : [];
    }
  },

  mounted() {
    // console.log(this.projectDetail, "store2");
    // 这里模拟ajax从后端返回数据后，如果渲染表单数据
    // window.setTimeout(() => {
    // 	this.fApi.setValue({
    // 		truename: 'adfasdf'
    // 	});
    // 	const rules = this.fApi.rule;
    // 	this.projectDetail.process.forEach(function(p, pi) {
    // 		if (p.name == 'zldj') {
    // 			rules.forEach(function(item, index) {
    // 				if (item.type == 'upload') {
    // 					console.log(index);
    // 					item.onSuccess = (response, file) => {
    // 						var filePath = response.data.data.url;
    // 						file.url = filePath;
    // 						return filePath;
    // 					}
    // 					console.log(item.props);
    // 				}
    // 			});
    // 		}
    // 	});
    // }, 1000);
  },

  data() {
    return {
      // 实例对象
      fApi: {},
      // Concurrency guard: prevent duplicate submissions
      isSubmitting: false,

      // 表单生成规则数组对象  生成规则：http://www.form-create.com/v2/guide/rule.html
      // 生成规则数组中一个对象就是一个表单项（是一个json对象），在里面可以对应的表单名称、类型、属性、值、样式、类名、是否必填、错误提示等。

      // 组件参数配置
      option: {
        // 显示重置表单按扭
        resetBtn: false,
        submitBtn: true,
        // 表单提交按扭事件
        //上传组件全局配置
        global: {
          upload: {
            props: {
              name: "file",
              type: "select",
              uploadType: "image",
              multiple: false,
              accept: "image/*",
              format: ["jpg", "jpeg", "png", "gif"],
              maxSize: 600,
              maxLength: 1,
              headers: {
                token: localStorage.getItem("token").replace(/\"/g, ""),
              },
              action: this.$common_upload,
              onSuccess: (file, fileList) => {
                if (file.code == 1) {
                  file.url = file.data.url;
                  fileList.url = file.url;
                  return file.url;
                } else {
                  this.$message.error(file.msg);
                }
              },
            },
          },
        },
        onSubmit: (formData) => {
          if (this.process.enable == 0) {
            this.$message.error("当前状态无法提交更改");
            return false;
          }

          // Concurrency guard: prevent duplicate submissions
          if (this.isSubmitting) {
            this.$message.warning("正在提交中，请勿重复操作");
            return false;
          }

          this.isSubmitting = true;
          this.fApi.btn.loading();

          reqProjectSavedata({
            form_data: formData,
            project_id: this.$parent.projectDetail.project_info.id,
          }).then((res) => {
            if (res.data.code === 1) {
              this.$message.success(res.data.msg);
              var temp_param = {
                project_id: this.$parent.projectDetail.project_info.id,
                step_name: "zldj",
              };
              reqProjectDetail(temp_param).then((res) => {
                if (res.data.code === 1) {
                  this.changeProject(res.data.data);
                  this.$parent.next();
                } else {
                  this.$message.success("资料已保存，请等待页面跳转");
                  this.isSubmitting = false;
                  this.fApi.btn.finish();
                }
              }).catch(() => {
                this.isSubmitting = false;
                this.fApi.btn.finish();
              });
            } else {
              this.$message.error(res.data.msg);
              this.isSubmitting = false;
              this.fApi.btn.finish();
            }
          }).catch(() => {
            this.$message.error("提交失败，请重试");
            this.isSubmitting = false;
            this.fApi.btn.finish();
          });
        },
      },
    };
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapActions(useMainStore, {
      changeProject: "updateProjectDetail",
    }),
    //考生文件
    checkFormData() {
      // Concurrency guard: prevent duplicate submissions
      if (this.isSubmitting) {
        this.$message.warning("正在提交中，请勿重复操作");
        return;
      }
      this.isSubmitting = true;

      reqProjectSavedata({
        form_data: JSON.stringify(this.fApi.formData()),
        project_id: this.$parent.projectDetail.project_info.id,
      }).then((res) => {
        if (res.data.code === 1) {
          var temp_param = {
            project_id: this.$parent.projectDetail.project_info.id,
            step_name: "zldj",
          };
          reqProjectDetail(temp_param).then((res) => {
            if (res.data.code === 1) {
              this.changeProject(res.data.data);
              this.$parent.next();
            } else {
              this.$message.success("资料已保存，请等待页面跳转");
              this.isSubmitting = false;
            }
          }).catch(() => {
            this.isSubmitting = false;
          });
        } else {
          this.$message.error(res.data.msg);
          this.isSubmitting = false;
        }
      }).catch(() => {
        this.$message.error("提交失败，请重试");
        this.isSubmitting = false;
      });
    },
  },
};
</script>

<style>
.inner-box {
  margin: 0px 20px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.next-step {
  color: #b8000d;
  border: #b8000d 1px solid;
  width: 60px;
  height: 30px;
  border-radius: 3px;
  margin-left: 30%;
  background-color: white;
  margin-top: 30px;
}

.pay-box {
  width: 90%;
}

.data {
  color: rgb(110, 105, 105);
  font-size: 14px;
  margin-top: 20px;
}

.two-line {
  height: 30px;
  border-radius: 3px;
  background-color: rgb(248, 246, 246);
  font-size: 14px;
  color: rgb(126, 121, 121);
  margin-top: 20px;
  width: 90%;
}

.positions {
  width: 250px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 40px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.position-text {
  font-size: 14px;
  color: rgb(121, 116, 116);
  margin-left: 40px;
  margin-top: 30px;
}

.position {
  width: 150px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 25px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.wram-tip {
  font-size: 15px;
  margin-left: 40px;
  color: rgb(126, 121, 121);
}

.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(231, 225, 225);
  margin-top: 10px;
}

.one-box {
  width: 80%;
  height: 200px;
  /* background-color: turquoise; */
  margin-top: 30px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.two-box {
  width: 80%;
  height: 150px;
  /* background-color: rgb(176, 204, 100); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.three-box {
  width: 80%;
  height: 300px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.submit:hover {
  transform: scale(1.1);
}

.submit {
  width: 100px;
  height: 30px;
  margin-top: 40px;
  background-color: white;
  border: rgb(204, 198, 198) 1px solid;
  border-radius: 3px;
  color: rgb(126, 121, 121);
}

.score-line {
  margin-top: 20px;
}

.big-box {
  width: 80%;
  margin-left: 10%;
}

.title {
  font-size: 16px;
  color: gray;
  margin-top: 20px;
}

.item-text {
  font-size: 16px;
  margin: 20px 10%;
  color: rgb(56, 55, 55);
}

.agree-sign-next {
  margin-top: 40px;
}

.agree-pro {
  margin-top: 11px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.s-sign {
  font-size: 14px;
  color: rgb(105, 103, 103);
  font-weight: 500;
  margin-top: 8px;
  margin-left: 40px;
}

.sign {
  width: 100px;
  height: 3px;
  background-color: rgb(161, 155, 155);
  margin-top: 30px;
  margin-left: 10px;
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}

.testprofile {
  width: 100%;
}

.el-steps--simple {
  width: 83%;
  margin: 0 auto;
  padding: 20px 50px;
  border-radius: 4px;
  background: #ffff !important;
  box-sizing: border-box;
}

.my-photo {
  font-size: 25px;
  color: #c2c1c1;
}

.my-headimg {
  width: 160px;
  height: 150px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.next-step {
  color: #b8000d;
  border: #b8000d 1px solid;
  width: 60px;
  height: 30px;
  box-sizing: content-box;
  padding: 2px;
  border-radius: 3px;
  margin-left: 30px;
  background-color: white;
  margin-top: 5px;
}

.data {
  color: rgb(110, 105, 105);
  font-size: 14px;
  margin-top: 20px;
}

.two-line {
  width: 96%;
  height: 30px;
  border-radius: 3px;
  margin-left: 2%;
  background-color: rgb(248, 246, 246);
  font-size: 14px;
  color: rgb(126, 121, 121);
  margin-top: 20px;
}

.positions {
  width: 250px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 40px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.position-text {
  font-size: 14px;
  color: rgb(121, 116, 116);
  margin-left: 40px;
  margin-top: 30px;
}

.position {
  width: 150px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 25px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.wram-tip {
  font-size: 15px;
  margin-left: 40px;
  color: rgb(126, 121, 121);
}

.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(231, 225, 225);
  margin-top: 10px;
}

.one-box {
  width: 80%;
  height: 200px;
  /* background-color: turquoise; */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.two-box {
  width: 80%;
  height: 150px;
  /* background-color: rgb(176, 204, 100); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.three-box {
  width: 80%;
  height: 150px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.submit:hover {
  transform: scale(1.1);
}

.three-box {
  width: 80%;
  height: 300px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.submit:hover {
  transform: scale(1.1);
}

.submit {
  width: 100px;
  height: 30px;
  margin-top: 40px;
  background-color: white;
  border: rgb(204, 198, 198) 1px solid;
  border-radius: 3px;
  color: rgb(126, 121, 121);
}

.sign-name {
  width: 100px;
  border: none;
  padding: 0 10px;
}

.el-step__title.is-success {
  color: #b8000d;
}

.el-step__head.is-success {
  color: #b8000d;
  border-color: #b8000d;
}

.el-step__icon.is-text {
  border-radius: 50%;
  border: 1px solid;
  border-color: inherit;
}
</style>
